import {
  Alert,
  Button,
  Card,
  Form,
  InputNumber,
  Popover,
  Typography,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import { BiInfoCircle } from "react-icons/bi";
import { useCurrency } from "../../provider/courtryProvider";
import { MdModeEditOutline } from "react-icons/md";
import { useState } from "react";
import config from "../../config";
import { useAccess } from "../../provider/AccessProvider";

const LoyaltyConfig = () => {
  const shopDetails = useSelector((state) => state.shopDetails);
  const currencyFormatter = useCurrency();
  const [showEdit, setShowEdit] = useState(false);
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const access = useAccess(["loyaltyConfiguration"]);

  console.log("shopDetails", shopDetails);
  const handleOnFinish = async (values) => {
    console.log("values", values);
    try {
      const response = await fetch(
        `${config.newApiGateway}/alias/updateAlias`,
        {
          method: "POST",
          body: JSON.stringify({
            loyaltyPoints: values.loyaltyPoints,
            loyaltyAmount: values.loyaltyAmount,
            action: "loyalty",
            shopId: shopDetails.shopId,
          }),
          headers: {
            "x-api-key": `${config.newApiKey}`,
            "Content-Type": "application/json",
          },
        }
      );
      const res = await response.json();
      console.log("res", res);
      if (res.code === "SUCCESS") {
        dispatch({
          type: "SET_LOYALTY",
          payload: res.data.Attributes,
        });
        return alert(res.message);
      }
    } catch (err) {
      alert("Error while updating Loyalty!!!");
    } finally {
      setLoading(false);
      setShowEdit(false);
    }
  };

  if (!access.loyaltyConfiguration(false)) {
    return (
      <Alert
        style={{ marginTop: "20px", padding: "20px", textAlign: "center" }}
        message="You don't have access, Please contact your administrator to request the appropriate access."
        type="error"
      />
    );
  }
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Card
        title="Loyalty Ratio"
        extra={
          <Popover
            content={
              <div
                style={{
                  width: 300,
                }}
              >
                <ul
                  style={{
                    paddingLeft: 16,
                  }}
                >
                  <li>
                    <Typography.Text>
                      1. Add only numbers to amount and points
                    </Typography.Text>
                  </li>
                  <li>
                    <Typography.Text>
                      2. Do not use decimals (Eg: 19.27)
                    </Typography.Text>
                  </li>
                  <li>
                    <Typography.Text>
                      3. Example [ 100 ₹ = 1Points ]
                    </Typography.Text>
                  </li>
                </ul>
                <Typography.Text>
                  If customer's order amount is 200 , 2 loyalty points will be
                  added to the customer.
                </Typography.Text>
              </div>
            }
            title="Instructions"
          >
            <BiInfoCircle
              style={{
                cursor: "pointer",
              }}
              size={28}
            />
          </Popover>
        }
        style={{ width: "400px" }}
        actions={[
          <>
            {showEdit ? (
              <div
                style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}
              >
                <Button
                  type="link"
                  danger
                  onClick={() => {
                    form.resetFields();
                    setShowEdit(false);
                  }}
                  loading={loading}
                >
                  <span
                    style={{
                      fontSize: 18,
                    }}
                  >
                    Cancel
                  </span>
                </Button>
                <Button
                  type="link"
                  onClick={() => {
                    form.submit();
                  }}
                  loading={loading}
                >
                  <span
                    style={{
                      fontSize: 18,
                    }}
                  >
                    Save
                  </span>
                </Button>
              </div>
            ) : (
              <Button
                type="link"
                onClick={() => {
                  setShowEdit(true);
                  form.setFieldsValue({
                    loyaltyPoints: Number(shopDetails.loyaltyPoints),
                    loyaltyAmount: Number(shopDetails.loyaltyAmount),
                  });
                }}
              >
                <MdModeEditOutline
                  style={{
                    marginRight: 4,
                  }}
                  size={20}
                />{" "}
                <span
                  style={{
                    fontSize: 18,
                  }}
                >
                  Edit
                </span>
              </Button>
            )}
          </>,
        ]}
      >
        <Typography.Text
          style={{
            textAlign: "center",
          }}
        >
          {!showEdit && (
            <>
              {!!(shopDetails.loyaltyPoints && shopDetails.loyaltyRatio) ? (
                <>
                  {shopDetails.loyaltyPoints} points for{" "}
                  {currencyFormatter(shopDetails.loyaltyAmount)}
                </>
              ) : (
                "No Loyalty Ratio found"
              )}
            </>
          )}

          {showEdit && (
            <>
              <Form
                onFinish={handleOnFinish}
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                form={form}
              >
                <Form.Item
                  label="Loyalty Amount"
                  rules={[
                    {
                      required: true,
                      message: "Loyalty amount is required",
                    },
                    {
                      type: "number",
                      min: 0,
                      message: "Loyalty amount should be greater than 0",
                    },
                    {
                      pattern: /^[0-9]+$/,
                      message: "Loyalty amount should be a number",
                    },
                  ]}
                  name="loyaltyAmount"
                >
                  <InputNumber
                    type="number"
                    style={{
                      width: "100%",
                    }}
                    placeholder="Eg: 100"
                    onWheel={(e) => e.target.blur()}
                  />
                </Form.Item>
                <Form.Item
                  label="Loyalty Points"
                  rules={[
                    {
                      required: true,
                      message: "Loyalty point is required",
                    },
                    {
                      type: "number",
                      min: 0,
                      message: "Loyalty point should be greater than 0",
                    },
                    {
                      pattern: /^[0-9]+$/,
                      message: "Loyalty point should be a number",
                    },
                  ]}
                  name="loyaltyPoints"
                >
                  <InputNumber
                    type="number"
                    style={{
                      width: "100%",
                    }}
                    placeholder="Eg: 1"
                    onWheel={(e) => e.target.blur()}
                  />
                </Form.Item>
              </Form>
            </>
          )}
        </Typography.Text>
      </Card>
    </div>
  );
};

export default LoyaltyConfig;
